import { UIComponentHandler, UIComponentState, UIDataModel, UIComponentProps, UIComponentImpl } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { ProfiletunesCategoryViewImpl } from './profiletunesview';
import { ProfiletunesCategoryCSSStyleImpl } from './profiletunescss';

import { FeaturedCategoryDto } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';
import { ProfiletunesCategoryAPIModel, ProfiletunesCategoryAPIModelImpl } from './profiletunesapimodel';

export interface ProfiletunesCategoryComponentProps extends UIComponentProps
{
    
}

export interface ProfiletunesCategoryComponentHandler extends UIComponentHandler
{
    
}

export class ProfiletunesCategoryComponent extends UIComponentImpl<ProfiletunesCategoryComponentProps, UIComponentState, UIDataModel> implements ProfiletunesCategoryComponentHandler
{
    constructor(props: ProfiletunesCategoryComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ProfiletunesCategoryViewImpl(applicationContext, uiComponentHandler);
    }

    componentDidMount()
    {
        (this.getAPIModel() as ProfiletunesCategoryAPIModel).getProfiletunesCategories();
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ProfiletunesCategoryCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ProfiletunesCategoryAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("featuer: " + (data as FeaturedCategoryDto).getListOfTones().length);
  
        (this.getView() as  ProfiletunesCategoryViewImpl)
        .updateData((data as FeaturedCategoryDto).getListOfTones(), true, 0, false);

        this.forceUpdate();
        // window.scrollTo(0,0);
    }

    onFailure(feature: APIFeatures, description: string, data: any)
    {
        // window.scrollTo(0,0);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunescomponent.tsx